import { LoadingIndicator, PageLoadingWrapper } from "src/styled";

const PageLoading = () => {
  return (
    <PageLoadingWrapper>
      <LoadingIndicator size="100px" />
    </PageLoadingWrapper>
  );
};

export default PageLoading;
